import { graphql } from '@/gql/graphql';

export const ChatMessageEmojiInputFragment = graphql(`
  fragment ChatMessageEmojiInput on message {
    id
    reaction_count
    your_reactions {
      id
      content
    }
  }
`);
